import React, { FC, ReactNode } from 'react';

import * as S from './LimitBanner.styles';

export const LimitBanner: FC<{ content: ReactNode; className?: string }> = ({
  content,
  className,
}) => <S.BannerText className={className}>{content}</S.BannerText>;
